var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438:15706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35168 14.567C0.525736 12.6829 0.559767 9.64473 2.39499 7.76755L8.95 1.06252C10.3349 -0.354109 12.586 -0.354234 13.971 1.06252C15.3425 2.46545 15.3442 4.72905 13.971 6.13364L8.25694 11.9728C7.32397 12.927 5.79965 12.9137 4.8825 11.9416C3.9989 11.005 4.02724 9.52055 4.92787 8.5993L9.41985 4.0107C9.61304 3.81339 9.9296 3.81002 10.1269 4.00317L10.8413 4.70252C11.0387 4.8957 11.042 5.21227 10.8489 5.40958L6.35734 9.99773C6.20322 10.1554 6.19372 10.4174 6.33709 10.5694C6.47372 10.7142 6.6885 10.7166 6.82734 10.5745L12.5414 4.73542C13.1543 4.10848 13.1543 3.08777 12.541 2.46048C11.9414 1.84714 10.9799 1.84683 10.38 2.46048L3.82493 9.16548C2.73858 10.2767 2.72183 12.0755 3.78771 13.1753C4.85053 14.2719 6.5685 14.2733 7.63328 13.1842L13.0102 7.68423C13.2032 7.48677 13.5198 7.4832 13.7172 7.67623L14.4321 8.37511C14.6296 8.56814 14.6332 8.8847 14.4401 9.08217L9.06325 14.5821C7.2015 16.4864 4.19003 16.4639 2.35168 14.567Z",
    fill: "#21C0F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438:15706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.ecd9b77c.svg";
export { ForwardRef as ReactComponent };